// extracted by mini-css-extract-plugin
module.exports = {"rewards__settings--sm":"styles_rewards__settings--sm__OVREa","rewards__settings--bg":"styles_rewards__settings--bg__1Brty"};